import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      '& div, & a': {
        marginRight: SMALL_MARGIN,
        '&:last-child': {
          marginRight: 0,
        },
        [theme.breakpoints.up('sm')]: {
          marginRight: MIDDLE_MARGIN,
        },
      },
    },
  }),
);

export default useStyles;
